import * as React from "react";
import { DateField, TextField, EditButton, TextInput } from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];

export const CategoryList = (props) => (
  <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <DateField source="created_at" label="Created At" />
      <IfCanAccess action="edit">
        <EditButton />
      </IfCanAccess>
    </Datagrid>
  </List>
);
